const CheckGroup = ({ name, options, checkedValues = [], onChange, type, disabled = false }) => {
    return (
        <>
            {options.map((option) => (
                <div key={option.id} className="item-checkBox">
                    <input
                        disabled={disabled}
                        type={type}
                        id={option.id}
                        name={name}
                        value={option.value}
                        checked={checkedValues.includes(option.value)}
                        onChange={onChange}
                    />
                    <span />
                    <label htmlFor={option.id}>{option.label}</label>
                </div>
            ))}
        </>
    );
};

export default CheckGroup;
